var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "image-modal__button",
          attrs: { "aria-label": "Öppna modal" },
          on: { click: _vm.toggleModal }
        },
        [
          _c("picture", [
            _c(
              "div",
              { staticClass: "image-modal__wrapper" },
              [
                _vm.src
                  ? _c("img", {
                      staticClass: "image-modal__image",
                      attrs: { src: _vm.src }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("v-icon", {
                  staticClass: "image-modal__zoom-in",
                  attrs: { name: "icon-zoom-in" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("figcaption")
          ])
        ]
      ),
      _vm._v(" "),
      _vm.showModal
        ? _c("v-modal", {
            attrs: { close: _vm.toggleModal, isImageModal: true },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function() {
                    return [_c("img", { attrs: { src: _vm.modalSrc } })]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              769043077
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }